let player;
const namespace = "presto-player.analytics";
let nonce = "";

export default function (pl) {
  player = pl;

  wp.hooks.addAction("presto.nonceRefreshed", namespace, (newNonce) => {
    nonce = newNonce;
  });

  wp.hooks.addAction("presto.playerPlay", namespace, sendVideoData);
  wp.hooks.addAction("presto.playerEnded", namespace, sendVideoData);
  wp.hooks.addAction("presto.playerHidden", namespace, sendVideoData);
  wp.hooks.addAction("presto.playerPause", namespace, sendVideoData);
  wp.hooks.addAction("presto.playerSeeked", namespace, sendVideoData);
}

export function videoData(player) {
  const data = {
    video_current_time: parseInt(player?.currentTime || 0),
    video_provider: player?.provider || "html5",
    ...(player?.duration ? { video_duration: parseInt(player?.duration) } : {}),
    ...(player?.source ? { video_url: player?.source } : {}),
    ...(player?.config?.title ? { video_title: player?.config?.title } : {}),
  };
  return data;
}

// send video data
export function sendVideoData(player) {
  sendData(videoData(player));
}

export function sendData(data) {
  prestoPlayer?.debug && console.log("Sending data...");
  if (!nonce) {
    prestoPlayer?.debug && console.log("Analytics nonce not set, bailing...");
    return;
  }

  if (!player.config.analytics) {
    prestoPlayer?.debug && console.log("Analytics disabled.", player);
    return;
  }

  let formData = new FormData();

  formData.append("action", "presto_player_progress");
  formData.append("duration", data?.video_current_time);
  formData.append("video_id", player?.config?.id);
  formData.append("nonce", nonce);

  if (!prestoPlayer?.debug_navigator) {
    let result = navigator.sendBeacon(window.prestoPlayer.ajaxurl, formData);
    if (prestoPlayer?.debug) {
      if (result) {
        console.log("Successfully queued analytics", [...formData]);
      } else {
        console.log("Failed to queue analytics", [...formData]);
      }
    }
  } else {
    jQuery.ajax({
      type: "POST",
      url: window.prestoPlayer.ajaxurl,
      dataType: "json",
      cache: false,
      data: {
        action: "presto_player_progress",
        video_id: player?.config?.id,
        duration: data?.video_current_time,
        nonce,
      },
      success: (...args) => {
        console.log(args);
      },
      error: (...args) => {
        console.error(args);
      },
    });
  }
}
